import { cn } from "@/libs/cn";
import { GridTableCell, Tooltip } from "@/modules/common/components";
import {
  TARIFF_CATEGORY_OPTIONS,
  TARIFF_MODALITY_OPTIONS,
  TARIFF_PERIOD_OPTIONS,
  TARIFF_SUBCATEGORY_OPTIONS,
  TARIFF_TENSION_SUBGROUP_OPTIONS,
  TARIFF_TYPE_OPTIONS,
} from "@/modules/common/types/AneelTariffs.enum";
import { AdminAneelTariffResponse } from "@/service/response/admin-aneel-tariffs";
import { formatCurrency, formatDate } from "@/modules/common/utils/format";

import { gridLayout } from "./TariffsListHeader";

interface TariffsListLineProps {
  tariff: AdminAneelTariffResponse;
}

const findLabel = (options: { value: string; label: string }[], value: number | null | undefined) => {
  if (value === null || value === undefined) return "-";
  return options.find((option) => option.value === String(value))?.label ?? "-";
};

const TariffsListLine = ({ tariff }: TariffsListLineProps) => {
  const rowClassName = cn(
    gridLayout,
    "bg-white border border-[#D6DEE9] md:rounded-none md:border-0 md:border-t md:bg-transparent rounded-lg",
  );

  const subcategoryLabel = findLabel(TARIFF_SUBCATEGORY_OPTIONS, tariff.subcategory);

  return (
    <div className={rowClassName}>
      <GridTableCell label="Nome" className="text-sm text-ui-navy-dark font-medium md:min-w-0">
        <Tooltip label={tariff.name}>
          <span className="block truncate">{tariff.name}</span>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Distribuidora" className="text-sm text-ui-navy-dark md:min-w-0">
        <Tooltip label={tariff.energyDistributorName} disabled={!tariff.energyDistributorName}>
          <span className="block truncate">{tariff.energyDistributorName ?? "-"}</span>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Modalidade" className="text-sm text-ui-navy-dark md:min-w-0 whitespace-nowrap">
        {findLabel(TARIFF_MODALITY_OPTIONS, tariff.modality)}
      </GridTableCell>

      <GridTableCell label="Subgrupo" className="text-sm text-ui-navy-dark whitespace-nowrap">
        {findLabel(TARIFF_TENSION_SUBGROUP_OPTIONS, tariff.tensionSubgroup)}
      </GridTableCell>

      <GridTableCell label="Classe/Categoria" className="text-sm text-ui-navy-dark md:min-w-0 whitespace-nowrap">
        {findLabel(TARIFF_CATEGORY_OPTIONS, tariff.category)}
      </GridTableCell>

      <GridTableCell label="Subclasse" className="text-sm text-ui-navy-dark md:min-w-0">
        <Tooltip label={subcategoryLabel} disabled={subcategoryLabel === "-"}>
          <span className="block truncate">{subcategoryLabel}</span>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Valor TE" className="text-sm text-ui-navy-dark whitespace-nowrap">
        {formatCurrency(tariff.teValue, 5, 5)}
      </GridTableCell>

      <GridTableCell label="Valor TUSD" className="text-sm text-ui-navy-dark whitespace-nowrap">
        {formatCurrency(tariff.tusdValue, 5, 5)}
      </GridTableCell>

      <GridTableCell label="Período" className="text-sm text-ui-navy-dark md:min-w-0 truncate">
        {findLabel(TARIFF_PERIOD_OPTIONS, tariff.period)}
      </GridTableCell>

      <GridTableCell label="Tipo" className="text-sm text-ui-navy-dark md:min-w-0 truncate">
        {findLabel(TARIFF_TYPE_OPTIONS, tariff.type)}
      </GridTableCell>

      <GridTableCell label="Início da vigência" className="text-sm text-ui-navy-dark whitespace-nowrap">
        {formatDate(tariff.effectiveDate, "DD/MM/YYYY")}
      </GridTableCell>

      <GridTableCell label="Fim da vigência" className="text-sm text-ui-navy-dark whitespace-nowrap">
        {formatDate(tariff.expirationDate, "DD/MM/YYYY")}
      </GridTableCell>
    </div>
  );
};

export default TariffsListLine;
